import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ManagerRestService {


  constructor( private http: HttpClient) {}

  prepareUrl( schoolId: number) {
    return environment.apiEndpoint + '/school/' + schoolId;
  }

  public listTeacherAllowances(schoolId: number, teacherId: number) {
    const url = this.prepareTeacherUrl(schoolId, teacherId) + '/allowance';
    return this.http.get<string[]>(url);
  }

  prepareTeacherUrl(schoolId: number, teacherId: number) {
    return this.prepareUrl(schoolId) + '/teachers/' + teacherId ;
  }
}
